module.exports = __webpack_public_path__ + "img/12_87.513768f4.png";